import { render } from "./login_as.vue?vue&type=template&id=47510ed2"
import script from "./login_as.vue?vue&type=script&lang=js"
export * from "./login_as.vue?vue&type=script&lang=js"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__